import { ChevronRight } from '@mui/icons-material';
import { Box, Grid, Typography, useMediaQuery } from '@mui/material';
import PropTypes from 'prop-types';
import { LinkButton, TranslucentContainer } from '../../../../../../components';
import CardEvent from '../../../components/CardEvent/CardEvent';
import { formatDate, formatTime, getFormattedTime } from '../../../../../../utils';
import { APP_ROUTES } from '../../../../../../constants/app-routes';

function eventRegisterLink(eventId = null) {
  if (!eventId) return '';
  return APP_ROUTES?.VENDOR_EVENT_REGISTRATION.replace(':id', eventId);
}

function EventList({ events, showDescription }) {
  // Custom breakpoints for responsive grid layout
  const isLargeScreen = useMediaQuery('(min-width: 1700px)'); // 4 per row at 1700px+
  const isMediumScreen = useMediaQuery('(min-width: 1300px)'); // 3 per row at 1300-1699px

  // Determine grid columns: 2 per row (1200-1299px), 3 per row (1300-1699px), 4 per row (1700px+)
  const getGridColumns = () => {
    if (isLargeScreen) return 3; // 4 per row
    if (isMediumScreen) return 4; // 3 per row
    return 6; // 2 per row (for lg breakpoint 1200-1299px)
  };
  const getFormattedDate = (event) => formatDate(event?.parameters_event?.event_date);
  const getFormattedPrice = (event) =>
    Number(event.event_price).toLocaleString('en-US', {
      style: 'currency',
      currency: 'USD',
    });
  const eventDetails = (eventId = null) => {
    if (eventId === undefined) return '';
    return APP_ROUTES?.EVENT_DETAILS.replace(':eventId', eventId);
  };

  return (
    <Grid container marginTop={5} justifyContent="center">
      <TranslucentContainer>
        <Grid container justifyContent="start" marginTop={8}>
          {events.map((e) => (
            <Grid key={e.id} item sm={5} lg={getGridColumns()} marginBottom={8} paddingLeft={8}>
              <CardEvent
                eventId={e.id}
                title={e.name}
                image={e.photo}
                caption={<span>{e.venue?.name}</span>}
                status={e.status}
                cardFooter={
                  <>
                    <LinkButton
                      to={eventDetails(e.id)}
                      variant="text"
                      sx={{ color: '#EE7B57', textTransform: 'none' }}>
                      Details
                      <ChevronRight sx={{ fill: '#EE7B57' }} />{' '}
                    </LinkButton>
                    {e.status && (
                      <LinkButton
                        to={eventRegisterLink(e.id)}
                        variant="text"
                        sx={{ color: '#EE7B57', textTransform: 'none' }}>
                        Apply <ChevronRight sx={{ fill: '#EE7B57' }} />{' '}
                      </LinkButton>
                    )}
                  </>
                }>
                <Box>
                  {e && (
                    <Typography gutterBottom variant="caption" color="text.secondary">
                      {getFormattedDate(e)}, {getFormattedTime(e)}
                    </Typography>
                  )}

                  {showDescription && (
                    <Typography gutterBottom variant="subtitle2" color="text.primary">
                      <>&bull; {e.description}</>
                    </Typography>
                  )}
                </Box>
              </CardEvent>
            </Grid>
          ))}
        </Grid>
      </TranslucentContainer>
    </Grid>
  );
}

EventList.propTypes = {
  events: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
      name: PropTypes.string.isRequired,
      description: PropTypes.string.isRequired,
      status: PropTypes.bool.isRequired,
    }),
  ).isRequired,
  showDescription: PropTypes.bool,
};

EventList.defaultProps = {
  showDescription: false,
};

export default EventList;
